import type { AnalyticsProvider } from './index';

export class SegmentProvider implements AnalyticsProvider {
  identify(userId?: string, traits?: Record<string, unknown>, options?: Record<string, unknown>): void {
    if (typeof window !== 'undefined' && window.analytics) {
      window.analytics.identify(userId, traits, { ...options });
    }
  }

  page(name?: string, properties?: Record<string, unknown>): void {
    if (typeof window !== 'undefined' && window.analytics) {
      window.analytics.page(name, properties);
    }
  }

  track(
    event: string,
    properties?: Record<string, unknown>,
    options?: Record<string, unknown>,
    callback?: () => void,
  ): void {
    if (typeof window !== 'undefined' && window.analytics) {
      if (callback) {
        window.analytics.track(event, properties, { ...options }, callback);
        return;
      }

      window.analytics.track(event, properties, { ...options });
    }
  }

  anonymousId() {
    if (typeof window !== 'undefined' && window.analytics && window.analytics?.user) {
      return window.analytics.user().anonymousId();
    }

    return null;
  }
}
